module.exports = __webpack_public_path__ + "static/media/inventory_black_24dp.f85a1c64.svg";